<template>
  <header class="flex h-[71px] w-full items-center border-b border-b-blue-light bg-white lg:h-24">
    <div class="mx-auto flex w-full max-w-screen-2xl justify-between">
      <div class="ml-9 flex items-center justify-center lg:ml-4 2xl:ml-0" v-if="!hideLogo">
        <NuxtLink :to="status === 'authenticated' ? '/' : '/login'">
          <SvgoBlixtappLogga class="aspect-[131/44] h-9 lg:h-11" filled />
        </NuxtLink>
      </div>

      <nav
        v-if="status === 'authenticated' && !hideNav"
        class="mx-auto hidden w-full max-w-[600px] items-center justify-between lg:flex"
      >
        <NuxtLink
          v-for="navItem in navItems"
          :key="navItem.to"
          :to="navItem.to"
          class="block fill-[#E6E7E8] p-4 transition-all duration-300 hover:fill-blue"
          :class="{ 'fill-blue': navItem.activeCondition }"
        >
          <component :is="navItem.icon" class="size-5" />
        </NuxtLink>
      </nav>

      <div class="w-[131px]" v-if="!hideLogo"></div>
    </div>
  </header>
</template>

<script setup lang="ts">
const { status } = useAuth()
const route = useRoute()

interface HeaderProps {
  hideNav?: boolean
  hideLogo?: boolean
}

withDefaults(defineProps<HeaderProps>(), {
  hideNav: false,
  hideLogo: false,
})

const navItems = computed(() => [
  {
    to: '/',
    icon: 'SvgoNavbarFlash',
    activeCondition: route.path === '/',
  },
  {
    to: '/awards',
    icon: 'SvgoNavbarBadge',
    activeCondition: route.path.startsWith('/awards'),
  },
    {
    to: '/wall-of-fame',
    icon: 'SvgoNavbarStar',
    activeCondition: route.path.includes('/wall-of-fame'),
  },
  {
    to: '/profile',
    icon: 'SvgoNavbarProfile',
    activeCondition: route.path.includes('/profile'),
  },
])
</script>
